export const useIsExtension = () => {
  const isExtension = window.location.pathname === '/magic-extension';
  return { isExtension };
};
